/**
 * YouTube Token Service
 * Stores and retrieves YouTube OAuth tokens
 */

import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const TOKENS_COLLECTION = 'youtubeTokens';

/**
 * Stores YouTube OAuth token for a user
 * @param {string} userId - User ID
 * @param {string} accessToken - OAuth access token
 * @param {number} expiresIn - Token expiration time in seconds
 * @returns {Promise<void>}
 */
export const storeYouTubeToken = async (userId, accessToken, expiresIn) => {
  if (!userId || !accessToken) {
    throw new Error('userId and accessToken are required');
  }

  try {
    const tokenRef = doc(db, TOKENS_COLLECTION, userId);
    const expiresAt = new Date(Date.now() + expiresIn * 1000);
    
    await setDoc(tokenRef, {
      userId,
      accessToken,
      expiresAt,
      createdAt: new Date(),
    }, { merge: true });
    
    console.log('Ô£à YouTube token stored');
  } catch (error) {
    console.error('Error storing YouTube token:', error);
    throw error;
  }
};

/**
 * Retrieves YouTube OAuth token for a user
 * @param {string} userId - User ID
 * @returns {Promise<Object|null>} Token data or null if not found/expired
 */
export const getYouTubeToken = async (userId) => {
  if (!userId) {
    return null;
  }

  try {
    const tokenRef = doc(db, TOKENS_COLLECTION, userId);
    const tokenSnap = await getDoc(tokenRef);
    
    if (!tokenSnap.exists()) {
      return null;
    }

    const data = tokenSnap.data();
    const expiresAt = data.expiresAt?.toDate();
    
    // Check if token is expired
    if (expiresAt && expiresAt < new Date()) {
      console.log('ÔÜá´©Å YouTube token expired');
      return null;
    }

    return {
      accessToken: data.accessToken,
      expiresAt,
    };
  } catch (error) {
    console.error('Error retrieving YouTube token:', error);
    return null;
  }
};



